// eslint-disable-next-line import/extensions
import wx from 'wx';

import store from '@/store';
import { MENU_ITEM_SHARE_APP_MESSAGE, MENU_ITEM_SHARE_TIMELINE } from '@/constants/jssdk';
import { WECHAT_JSSDK } from '@/store/wechat/types';

const wechat = {
    promise: null,
    config(url) {
        const promise = new Promise((resolve, reject) => {
            store.dispatch(`wechat/${WECHAT_JSSDK}`, { url })
                .then(() => {
                    wx.config(store.state.wechat.jssdk);
                    wx.ready(() => {
                        wx.hideAllNonBaseMenuItem();
                        resolve(wx);
                    });
                    wx.error(err => reject(err));
                })
                .catch(reason => reject(reason));
        });
        wechat.promise = promise;
        return promise;
    },
    ready() {
        return wechat.promise;
    },
    showMenuItem(menu) {
        wx.showMenuItems({
            menuList: [menu],
        });
    },
    shareTimeline(options) {
        const { title, link, imgUrl, success } = options;
        wx.onMenuShareTimeline({
            title,
            link,
            imgUrl,
            success,
        });
        this.showMenuItem(MENU_ITEM_SHARE_TIMELINE);
    },
    shareAppMessage(options) {
        const { title, desc, link, imgUrl, success } = options;
        wx.onMenuShareAppMessage({
            title,
            desc,
            link,
            imgUrl,
            success,
        });
        this.showMenuItem(MENU_ITEM_SHARE_APP_MESSAGE);
    },
    closeWindow() {
        wx.closeWindow();
    },
};

export default wechat;



// WEBPACK FOOTER //
// ./src/plugins/wechat/wechat.js